import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-photo_add",
  "use": "icon-photo_add-usage",
  "viewBox": "0 0 70 70",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70 70\" id=\"icon-photo_add\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h70v70H0z\" /><path fill=\"#B3B3B3\" d=\"M32.083 32.083v-17.5h5.834v17.5h17.5v5.834h-17.5v17.5h-5.834v-17.5h-17.5v-5.834z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol